if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      setButtonLoading(button, loading) {
        if (!button) return;
        const label = button.querySelector("span");
        if (label && !button.dataset.originalLabel) button.dataset.originalLabel = label.textContent.trim();
        if (label) label.textContent = loading ? (button.dataset.loadingText || "Toevoegen…") : (button.dataset.originalLabel || label.textContent);
        button.toggleAttribute("aria-busy", loading);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;
        this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.setButtonLoading(submitButton, true);
        this.querySelector(".button-overlay-spinner")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.minicart) formData.append("sections", this.minicart.getSectionsToRender().map((section) => section.section));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source:"product-form", productVariantId:formData.get("id"), errors:response.errors || response.description, message:response.message });
              this.handleErrorMessage(response.description);
              this.minicart?.updateSectionContents();
              return;
            }
            this.minicart?.renderContents(response);
            if (!this.minicart || window.themeSettings.redirectToCart) location.href = window.routes.cart_url;
            else this.minicart.open(submitButton);
            document.dispatchEvent(new CustomEvent("cart:item-add", { detail:{items:[response],context:this.eventContext} }));
            publish(PUB_SUB_EVENTS.cartItemAdd, { source:this.eventContext, items:[response] });
          })
          .catch((error) => { console.error(error); this.handleErrorMessage("Toevoegen aan de winkelwagen is niet gelukt. Probeer opnieuw."); })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.setButtonLoading(submitButton, false);
            this.querySelector(".button-overlay-spinner")?.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form-error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }
    },
  );
}
